export * from "./mensmagazine";

// Sportiva関連定数定義
/** 連携名 */
export const WEB_SPORTIVA_LINKAGE_NAME = "WebSportiva";
/** 画面パス */
export const WEB_SPORTIVA_MAGAZINE_PATH = "web_sportiva";
/** デフォルトコールバックURL */
export const WEB_SPORTIVA_DEFAULT_CALLBACK_URL = process.env.VUE_APP_WEB_SPORTIVA_DEFAULT_CALLBACK_URL;
/** 許容コールバックURL */
export const WEB_SPORTIVA_ACCEPT_CALLBACK_URLS = process.env.VUE_APP_WEB_SPORTIVA_ACCEPT_CALLBACK_URLS.split(",").map((url: string) => `^${url}(\\?.*)?$`);
/** サービス規約URL */
export const WEB_SPORTIVA_SERVICE_TERM_URL = process.env.VUE_APP_WEB_SPORTIVA_SERVICE_TERM_URL;
/** メールアドレスドメイン */
export const WEB_SPORTIVA_EMAIL_DOMAINS = [
    "sportiva.shueisha.co.jp",
    "sportiva.sid.shueisha.co.jp",
];
/** 連携サブID */
export const WEB_SPORTIVA_LINKAGE_SUB_ID = 1;
